<template>
  <div class="home">
    <view-list :list="list" :isGroup="true" :total="total"></view-list>
  </div>
</template>

<script>
import Session from '../utils/session'
import Footer from '@/components/footer.vue'
import API from '@/service/API'
import ViewList from '@/components/viewList'
export default {
  name: 'Home',
  data(){
    return {
      list: [],
      total: 0,
    }
  },
  components: {
    ViewList,
    Footer
  },
  watch: {
    '$route': function() {
      this.getList()
    }
  },
  mounted(){
    this.getList()
    document.title = this.$route.meta.title
    if(window.wx){
      // 禁止分享
      wx.hideMenuItems({
        showAllNonBaseMenuItem: [] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      });
    }
  },
  methods:{
    getList(){
      let params = {
        photo_group: this.$route.params.id
      }
      API.getPhotoGroup(params).then( res => {
        this.$data.list = res.data
        this.$data.total = res.data.length
      })
    }
  }
}
</script>